/**
 * Shared menu structure for NaturStore desktop + mobile navigation.
 * Menu groups map translation keys to Bagisto category slugs.
 */

/** Menu groups: label + which category slugs to show in each column */
export const MENU_GROUPS: {
  labelKey: string
  slugs: string[][] // array of columns, each column is array of slugs
  childColumns?: number // render children in N columns (default 1)
  /**
   * Optional editorial/service banner rendered at the bottom of the mega menu.
   * `titleKey` and `descriptionKey` are resolved against `layout.header.nav.*`.
   */
  banner?: {
    titleKey: string
    descriptionKey: string
    href: string
  }
}[] = [
  {
    labelKey: "skincare",
    slugs: [["skincare"]],
    childColumns: 2,
  },
  { labelKey: "bodyAndHair", slugs: [["body"], ["hair"]] },
  {
    labelKey: "makeup",
    slugs: [["makeup"]],
    childColumns: 2,
  },
  { labelKey: "wellness", slugs: [["wellness"]] },
  { labelKey: "mouthHygiene", slugs: [["mouth-hygiene"]] },
  { labelKey: "home", slugs: [["home"]] },
  { labelKey: "fragrance", slugs: [["fragrance"]] },
]

/** Direct link items rendered right after DYNAMIC_GROUPS (e.g. next to Brands) */
export const PRIMARY_LINKS: { labelKey: string; href: string }[] = [
  { labelKey: "shop", href: "/products" },
]

/** Direct link items rendered after MENU_GROUPS (end of nav) */
export const DIRECT_LINKS: { labelKey: string; slug?: string; href?: string }[] = []

/**
 * Dynamic menu groups — dropdown content comes from GraphQL, not static slugs.
 * Currently only `brands` is wired up; extend with more kinds as needed.
 * Keeping the order explicit here decides where the group sits in the nav.
 */
export const DYNAMIC_GROUPS: { labelKey: string; kind: "brands" }[] = [
  { labelKey: "allBrands", kind: "brands" },
]
